module.exports = __webpack_public_path__ + "static/media/illustration-cloud-fixplay.09bb82c6.svg";